import { TenantJob } from '~/tenants/common/TenantJob';
import { DemoOrderContext, DemoPerformableConfig } from '~/tenants/demo/model/DemoOrder';

export default abstract class DemoJob<P extends DemoPerformableConfig> extends TenantJob<DemoOrderContext, P> {}
